import { render, staticRenderFns } from "./UploadDocumentTable.vue?vue&type=template&id=90dadb8a&"
import script from "./UploadDocumentTable.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports